import { connect } from 'react-redux';
import { FILTERS_COUPLES } from '../../constants/SettingsKeys';

import {
    fetchCouplesIfNeeded,
    setCouplesFilters,
    setCouplesDefFilters,
    sortCouples,
    WARNINGS
} from '../../actions/CouplesActions';

import CouplesSettings from '../../components/CouplesSettings/CouplesSettings';
import {invalidateProject} from "../../actions/setters";

const mapStateToProps = (state, ownProps) => {
    //const { selectedProject } = state.leaksList;
    const selectedProject = state.leaksList.selectedProject;
    let couples = [];
    if (state.leaksList.leaksByProject[selectedProject]) {
      couples = state.leaksList.leaksByProject[selectedProject].couples.couples;
    }

    // for display only type the exist in the project:
    // ( NOT IN USE. after filtering is display only the filtered items in the select dropdown)
    let tempMaterialsList = [];
    let materialsList = [];
    couples.forEach(couple => {
        const material = couple.Material;
        if (tempMaterialsList.indexOf(material) === -1) {
            tempMaterialsList.push(material);
            materialsList.push({ value: material, label: material });
        }
    });

  return Object.assign({}, {
      selectedProject,
      materialsList,
      initialValues: state.leaksList.filters.couples.defFilters,
      optionList: state.leaksList.optionList.options
  }, ownProps);
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onSubmit: (values, dispatch, props) => {
      const {selectedProject, processFilters, cleanEmptyFilters} = props;
      
      // Process filters
      const valuesCopy = Object.assign({}, values);
      // Remove ActivityStatus from values before processing to handle it separately
      const activityStatus = valuesCopy.ActivityStatus;
      delete valuesCopy.ActivityStatus;
      
      var filters = processFilters(valuesCopy);
      
      // Store activity status in defFilters to persist selection
      if (activityStatus) {
        filters.defFilters.ActivityStatus = activityStatus;
        
        // Add custom filter for activity status
        filters.filters.push({
          field: 'ActivityStatus',
          value: activityStatus,
          clientSide: true
        });
      }
      dispatch(invalidateProject(selectedProject));
      dispatch(setCouplesDefFilters(filters.defFilters));
      const cleanedFilters = cleanEmptyFilters(filters.filters);
      dispatch(setCouplesFilters(cleanedFilters));
      dispatch(sortCouples(filters.sort.field, filters.sort.dir));
			dispatch(fetchCouplesIfNeeded(selectedProject));

			localStorage.setItem(FILTERS_COUPLES, JSON.stringify(filters.defFilters));
			
			// Close the settings panel after successful submission
			if (props.toggleSettingsDisplay) {
			  props.toggleSettingsDisplay();
			}
    }
  };
};

const CCouplesSettings = connect(
  mapStateToProps,
  mapDispatchToProps
)(CouplesSettings);

export default CCouplesSettings;
